const menu = function () {
  const triggers = document.querySelectorAll(".trigger");
  if (!triggers.length) return;

  let active = false;
  const menuTrigger = document.querySelector(".menu.trigger");
  const span = menuTrigger.querySelector("span");

  const open = (menu) => {
    span.innerText = "Close menu";
    document.body.classList.add("menu-open");
    menuTrigger.setAttribute("data-active", menu);

    document.documentElement.addEventListener("click", (ev) => {
      if (
        active &&
        !ev.target.closest(".dropdown") &&
        !ev.target.closest(".site-header")
      ) {
        close();
      }
    });
    setTimeout(() => {
      active = true;
    }, 500);
  };

  const close = () => {
    span.innerText = "Menu";
    document.body.classList.remove("menu-open");
    menuTrigger.removeAttribute("data-active");
    active = false;
  };

  const change = (menu) => {
    menuTrigger.setAttribute("data-active", menu);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (ev) => {
      ev.preventDefault();
      const menu = trigger.dataset.src;

      if (!active) {
        open(menu);
      } else if (active && menu != "main") {
        change(menu);
      } else if (active && menu === "main") {
        close();
      }
    });
  });
};

export default menu;
